import React from "react";
import {Navigate, useLocation} from "react-router-dom";

const Authmiddleware = (props) => {
  const location = useLocation();
  if (!localStorage.getItem("authUser")) {
    let nextUrl = location.pathname;
    if (nextUrl !== "/login") {
      // Remove ? from the start of the string
      let location_search = location.search.substring(1)
      location_search = "&" + location_search
      nextUrl = encodeURIComponent(nextUrl);
      nextUrl = nextUrl + location_search
      return (
        <Navigate to={{pathname: "/login", search: `?next=${nextUrl}`, state: {from: location}}}/>
      );
    } else {
      return (
        <Navigate to={{pathname: '/login', state: {from: location}}}/>
      );
    }
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;